/** Shared UI helpers */
export function formatDate(iso: string | null | undefined, lang = 'ru'): string {
  if (!iso) return '—';
  const d = new Date(iso);
  return d.toLocaleString(lang === 'ru' ? 'ru-RU' : 'en-US', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

export function formatTime(iso: string | null | undefined, lang = 'ru'): string {
  if (!iso) return '';
  return new Date(iso).toLocaleTimeString(lang === 'ru' ? 'ru-RU' : 'en-US', {
    hour: '2-digit',
    minute: '2-digit',
  });
}

export function dayKey(iso: string): string {
  const d = new Date(iso);
  return `${d.getFullYear()}-${d.getMonth() + 1}-${d.getDate()}`;
}

export function formatDaySeparator(iso: string, lang = 'ru'): string {
  const d = new Date(iso);
  const today = new Date();
  const yesterday = new Date();
  yesterday.setDate(today.getDate() - 1);
  const same = (a: Date, b: Date) =>
    a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate();
  if (same(d, today)) return lang === 'ru' ? 'Сегодня' : 'Today';
  if (same(d, yesterday)) return lang === 'ru' ? 'Вчера' : 'Yesterday';
  return d.toLocaleDateString(lang === 'ru' ? 'ru-RU' : 'en-US', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  });
}

export function formatMoney(amount: string | number, lang = 'ru'): string {
  const n = typeof amount === 'string' ? parseFloat(amount) : amount;
  if (Number.isNaN(n)) return String(amount);
  return lang === 'ru' ? `${n.toFixed(0)} ₽` : `$${n.toFixed(2)}`;
}

export function subStatusLabel(status: string): string {
  switch (status) {
    case 'active':
      return 'Активна';
    case 'expired':
      return 'Истекла';
    default:
      return 'Нет';
  }
}

/** Russian plural for «сервер»: 1 сервер, 2–4 сервера, 5+ серверов */
export function pluralServers(count: number): string {
  const n = Math.abs(count) % 100;
  const n1 = n % 10;
  if (n > 10 && n < 20) return `${count} серверов`;
  if (n1 > 1 && n1 < 5) return `${count} сервера`;
  if (n1 === 1) return `${count} сервер`;
  return `${count} серверов`;
}

export function subStatusClass(status: string): string {
  switch (status) {
    case 'active':
      return 'badge badge-success';
    case 'expired':
      return 'badge badge-warning';
    default:
      return 'badge badge-muted';
  }
}
